export const styles = {
  header: {
    marginTop: 2,
    marginBottom: 2,
  },
};
